import React, { useEffect } from 'react';
import { NavLink } from 'react-router-dom';
import {
    BiCartAlt,
    BiUserCircle, 
    BiX
} from 'react-icons/bi';
import Hamburger from 'components/Navbar/Hamburger';
import ButtonLink from 'components/ButtonLink';
import TSCCLogo from 'assets/images/TSCCLogoText.webp'
import { useAppDispatch, useAppSelector } from 'hooks/useStore';
import { closeMessage } from 'store/cart';
import './index.css';

function Navbar({ transparent }: { transparent: boolean; }) {
    const { authenticated } = useAppSelector(state => state.user);
    const {
        bundles,
        courses,
        tests,
        updatedCart
    } = useAppSelector(state => state.cart);
    const { courses: myCourses } = useAppSelector(state => state.classroom);
    const dispatch = useAppDispatch();

    const activeLinkClassName = transparent
        ? 'navbar__link--active--transparent'
        : 'navbar__link--active';

    const numCartItems = courses.length + tests.filter(test => !test.addOn).length + bundles.reduce((count, bundle) => (
        count + (bundle.numRequired ? 0 : (bundle.courses.length + bundle.tests.length))
    ), 0);

    return (
        <div className={transparent ? 'navbar--transparent' : 'navbar'}>
            <div className='navbar__content'>
                {updatedCart &&
                    <div className='navbar__cartAdded'>
                        <div className='navbar__cartAddedHeader'>
                            <BiCartAlt className='navbar__cartAddedIcon' />
                            <p className='navbar__cartAddedTitle'>
                                Your cart - {numCartItems} {numCartItems > 1 ? 'items' : 'item'} added
                            </p>
                            <BiX
                                className='navbar__cartAddedClose'
                                onClick={() => dispatch(closeMessage())}
                            />
                        </div>
                        <ButtonLink
                            className='navbar__cartAddedButton'
                            to='/cart'
                            onClick={() => dispatch(closeMessage())}
                        >
                            VIEW CART
                        </ButtonLink>
                    </div>
                }
                {/* <Link to='/'>
                    <img 
                        src={TSCCLogo} 
                        alt='The SAT Crash Course'
                        className='navbar__logo'
                    />
                </Link> */}
                <a href='https://thesatcrashcourse.com'>
                    <img 
                        src={TSCCLogo} 
                        alt='The SAT Crash Course'
                        className='navbar__logo'
                    />
                </a>
                <div className='navbar__links'> 
                    <NavLink 
                        to='/courses'
                        className={({ isActive }) => (
                            isActive ? activeLinkClassName : 'navbar__link'
                        )}
                    >
                        Courses
                    </NavLink>
                    {/* <NavLink
                        to='/tests'
                        className={({ isActive }) => (
                            isActive ? activeLinkClassName : 'navbar__link'
                        )}
                    >
                        Tests
                    </NavLink> */}
                    <NavLink
                        to='/tests/digital-sat'
                        className={({ isActive }) => (
                            isActive ? activeLinkClassName : 'navbar__link'
                        )}
                    >
                        SAT
                    </NavLink>
                    <NavLink
                        to='/tests/digital-psat'
                        className={({ isActive }) => (
                            isActive ? activeLinkClassName : 'navbar__link'
                        )}
                    >
                        PSAT
                    </NavLink>
                    <NavLink
                        to='/tests/digital-act'
                        className={({ isActive }) => (
                            isActive ? activeLinkClassName : 'navbar__link'
                        )}
                    >
                        ACT
                    </NavLink>
                    <NavLink
                        to='/sat-or-act'
                        className={({ isActive }) => (
                            isActive ? activeLinkClassName : 'navbar__link'
                        )}
                    >
                        SAT or ACT?
                    </NavLink>
                    {authenticated
                        ?   <>
                                <NavLink
                                    to='/cart'
                                    className={({ isActive }) => (
                                        isActive ? 'navbar__link--active' : 'navbar__link'
                                    )}
                                >
                                    {(courses.length > 0 || tests.length > 0 || bundles.length > 0) && 
                                        <p className='navbar__cartBadge'>{numCartItems}</p>
                                    }
                                    <BiCartAlt className='navbar__icon' />
                                </NavLink>
                                <NavLink
                                    to='/account'
                                    className={({ isActive }) => (
                                        isActive ? activeLinkClassName : 'navbar__link'
                                    )}
                                >
                                    <BiUserCircle className='navbar__icon' />
                                </NavLink>
                            </>
                        :   <NavLink 
                                to="/sign-in"
                                className={({ isActive }) => (
                                    isActive ? activeLinkClassName : 'navbar__link'
                                )}
                            >
                                Sign In
                            </NavLink>
                    }
                </div>
                <Hamburger transparent={transparent} />
            </div>
        </div>
    );
}

export default Navbar;